import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgendaService } from '../services/agenda.service';
import { addDays, format, subDays, addMinutes, startOfDay } from 'date-fns';
import { CommonModule } from '@angular/common';
import { ViewAgendamentoComponent } from '../view-agendamento/view-agendamento.component';
import { CriarAgendamentoComponent } from '../criar-agendamento/criar-agendamento.component';
import { forkJoin, catchError, of } from 'rxjs';

export enum statusSchedule {
  confirmed = 'Confirmado',
  scheduled = 'Agendado',
  canceled = 'Cancelado',
  rescheduled = 'Remarcado',
  in_progress = 'Em Atendimento',
  completed = 'Finalizado',
  no_show = 'Faltou',
}

@Component({
  selector: 'app-view-agenda',
  standalone: true,
  imports: [CommonModule, ViewAgendamentoComponent, CriarAgendamentoComponent],
  templateUrl: './view-agenda.component.html',
  styleUrls: ['./view-agenda.component.scss'],
})
export class ViewAgendaComponent implements OnInit {
  public isLoadingAgendamentos: boolean = false;

  public scheduleId!: string;
  public cabecalhoAgenda: Date[] = [];
  public offset: number = 0;
  public agendamentos: Array<any> = [];

  public statusSchedule = statusSchedule;

  public openModalAppointment: boolean = false;
  public openModalNewAppointment: boolean = false;
  public appointmentSelected: any;
  public infoAppointmentCreate: any;
  public arrFittings!: Array<any>;

  constructor(
    private readonly router: Router,
    private readonly agendaService: AgendaService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.gerarCabecalho();
  }

  gerarCabecalho() {
    const now = startOfDay(new Date()); // evita problemas de hora
    this.cabecalhoAgenda = [];

    for (let i = -3; i <= 3; i++) {
      this.cabecalhoAgenda.push(addDays(now, i + this.offset));
    }

    this.carregarAgendamentos();
  }

  formatNameClient(name: string){
    return name.substring(0,18);
  }

  navegarEsquerda() {
    this.offset -= 7; 
    this.gerarCabecalho();
  }

  navegarDireita() {
    this.offset += 7;
    this.gerarCabecalho();
  }

  carregarAgendamentos() {
    this.isLoadingAgendamentos = true;
    const uri = this.router.url.split('/');
    const scheduleId = uri[uri.length - 1];
    this.scheduleId = scheduleId;

    const requisicoes = this.cabecalhoAgenda.map((dia: Date) => {
      const dataFormatada = format(dia, 'yyyy-MM-dd');
      return this.agendaService.getTimesAgenda(scheduleId, dataFormatada).pipe(
        catchError((err) => {
          console.error(`Erro ao buscar dia ${dataFormatada}`, err);
          return of([]); // retorna array vazio para não travar o forkJoin
        })
      );
    });

    forkJoin(requisicoes).subscribe({
      next: (respostas: any[][]) => {
        this.agendamentos = respostas.flat();
        this.isLoadingAgendamentos = false;
        this.cd.detectChanges();
      },
      error: (err) => {
        console.error('Erro inesperado no forkJoin', err);
        this.isLoadingAgendamentos = false;
      },
    });
  }

  filtrarPorData(agendamentos: Array<any>, dataDesejada: Date): Array<any> {
    const dataFormatada = format(dataDesejada, 'yyyy-MM-dd');
    return agendamentos.filter((item) => item.date === dataFormatada);
  }

  getStatusEnum(status: keyof typeof statusSchedule): string {
    return this.statusSchedule[status];
  }

  handleBackPage() {
    this.router.navigate(['/app/agendas']);
  }

  handleOpenModalAppointment(appointment: any) {
    if (appointment.agendamento.length > 0) {
      this.openModalAppointment = true;
      this.appointmentSelected = appointment.agendamento[0];
      this.arrFittings = appointment.agendamento
    } else {
      this.infoAppointmentCreate = appointment;
      this.openModalNewAppointment = true;
    }
  }

  handleCloseModalAppointment() {
    this.openModalAppointment = false;
    this.openModalNewAppointment = false;
  }

  handleRechargeAppointments() {
    this.handleCloseModalAppointment();
    this.carregarAgendamentos();
  }

  trackByAgendamentos(index: number, item: any): any {
    return item.id; // ou qualquer propriedade única (ex: item.codigo)
  }

  trackByHora(index: number, item: any): string {
    return item.time; // ou outro identificador único
  }
}
